document.addEventListener('click', (event) => {
  const filterCloseButton = event.target.closest('.collection-all-alard .mobile-facets__close');
  if (filterCloseButton) {
    event.preventDefault();
    filterCloseButton.closest('.mobile-facets__disclosure')?.removeAttribute('open');
    document.documentElement.classList.remove('collection-mobile-sheet-open');
    return;
  }

  const sortOpenButton = event.target.closest('[data-mobile-sort-open]');
  if (sortOpenButton) {
    sortOpenButton.closest('[data-collection-mobile-sort]')?.querySelector('[data-mobile-sort-overlay]')?.removeAttribute('hidden');
    document.documentElement.classList.add('collection-mobile-sheet-open');
  }

  const closeButton = event.target.closest('[data-mobile-sheet-close]');
  if (closeButton) {
    closeButton.closest('[data-mobile-sort-overlay]')?.setAttribute('hidden', '');
    document.documentElement.classList.remove('collection-mobile-sheet-open');
  }

  const overlay = event.target.closest('.collection-all-mobile-sheet-overlay');
  if (overlay && event.target === overlay) {
    overlay.setAttribute('hidden', '');
    document.documentElement.classList.remove('collection-mobile-sheet-open');
  }
});

document.addEventListener('toggle', (event) => {
  if (!event.target.matches('.collection-all-alard .mobile-facets__disclosure')) return;

  document.documentElement.classList.toggle('collection-mobile-sheet-open', event.target.open);
  if (!event.target.open) return;

  event.target.querySelectorAll('.mobile-facets__details').forEach((details) => {
    if (details.id?.includes('SortBy')) return;
    details.setAttribute('open', '');
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'true');
  });
}, true);
